import { latestUpdates } from '@/mocks/home';
import SectionHeading from '@/components/base/SectionHeading';

export default function LatestUpdates() {
  return (
    <section id="updates" className="w-full scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="更新动态"
              title="持续汇总，按节奏更新"
              desc="新增条目会先出现在这里，随后统一归入索引归档，方便回看，也方便跟进最近变化。"
            />
            <div className="mt-8 rounded-xl border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2 text-primary-600">
                <i className="ri-refresh-line" />
                <span className="font-label text-[12px]">最近 7 天更新</span>
              </div>
              <p className="mt-3 font-heading text-3xl font-black text-foreground-950">318 条</p>
              <p className="mt-2 text-xs leading-relaxed text-foreground-500">
                覆盖内容聚合、资源合集、分类大全与索引导航等分类维度。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-50">
              {latestUpdates.map((item) => (
                <li
                  key={item.time + item.title}
                  className="flex flex-col gap-2 px-5 py-4 transition-colors hover:bg-background-100 sm:flex-row sm:items-center sm:gap-5"
                >
                  <span className="flex w-28 shrink-0 items-center gap-2 font-label text-[12px] text-foreground-400">
                    <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                    {item.time}
                  </span>
                  <a
                    href="#summary"
                    className="min-w-0 flex-1 cursor-pointer truncate font-label text-sm text-foreground-800 transition-colors hover:text-primary-700"
                  >
                    {item.title}
                  </a>
                  <span className="w-fit shrink-0 rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900">
                    {item.category}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}